import './globals.css'
import './locales/i18n' // Initialize i18n

import React from 'react'
import ReactDOM from 'react-dom/client'

import type { LangCode } from '@/services/schemas.ts'

import App from './App.tsx'

const rootEl = document.getElementById('root')
const defaultLang = (import.meta.env.VITE_DEFAULT_LANG as LangCode) || 'en'
const siteLang: LangCode = rootEl?.getAttribute('data-sitelanguage') as LangCode || defaultLang

ReactDOM.createRoot(document.getElementById('root')!).render(

  <React.StrictMode>
    <App siteLang={siteLang} />
  </React.StrictMode>,
)
